import PrinterStorage from '../storage/printer-storage/PrinterStorage'

/**
 * Physical label stock the server can render for. Order matters — the drawer row
 * cycles through this list on each tap.
 */
export const getAvailableLabelSizes = (): string[] => ['4x4', '4x6', '2x1']

/**
 * 4x4 is the default because it is what every existing installation prints today.
 * Changing this silently changes the stock every unconfigured tablet asks for.
 */
export const DEFAULT_LABEL_SIZE = '4x4'

const isSupportedLabelSize = (value: string | undefined): value is string =>
  !!value && getAvailableLabelSizes().includes(value)

/**
 * Read per print rather than cached: the seller can change this from the drawer at any
 * time and the data handler that consumes it is a module-scope singleton.
 */
export const getLabelSize = (): string => {
  const storedSize = PrinterStorage.getLabelSize()

  return isSupportedLabelSize(storedSize) ? storedSize : DEFAULT_LABEL_SIZE
}

export const setLabelSize = (size: string): void => PrinterStorage.setLabelSize(size)

/**
 * Seeds the label size from the per-vendor default the server reports.
 *
 * Only fills an empty slot — a seller who has picked a size on this tablet keeps it,
 * because settings are re-fetched on a timer and would otherwise reset their choice on
 * every poll. An unrecognised server value is ignored rather than stored, so a size
 * this build cannot render never reaches the request.
 */
export const applyServerDefaultLabelSize = (serverSize: string | null | undefined): void => {
  if (!isSupportedLabelSize(serverSize ?? undefined)) {
    return
  }

  if (PrinterStorage.getLabelSize()) {
    return
  }

  PrinterStorage.setLabelSize(serverSize as string)
}
